import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import { Col, FormGroup, Input, Row } from "reactstrap";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import LaddersDataService from "../../../services/LaddersService";
import MessageTemplateService from "../../../services/MessageTemplateService";
import PortFolioService from "../../../services/PortfolioService";
import Loading from "../../../components/Loading/Loading";
import "./ParentPassion.scss";

// Import Advert component for Google ads
import Advert from "../../../components/Advert/Advert";

// Import check/uncheck icons
import checkIcon from "../../../assets/images/bragBook/check.png";
import unCheckIcon from "../../../assets/images/bragBook/unCheck.png";

const ParentPassion = () => {
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState(false);
  const [langVal, setLangVal] = useState("en");
  const [studentList, setStudentList] = useState([]);
  const [studentId, setStudentId] = useState();
  const [allInterest, setAllInterest] = useState([]);
  const [interestList, setInterestList] = useState([]);
  const [chekcedInterest, setChekcedInterest] = useState([]);

  const handleChangeLanguage = (checked) => {
    setLanguage(checked);
    let language = checked === true ? "es" : "en";
    setLangVal(language);

    if (language === "es" && interestList && interestList.length > 0) {
      getTranslatedVal(language, interestList);
    } else {
      setInterestList(
        allInterest.map((a) => {
          return { ...a };
        })
      );
    }
  };

  useEffect(() => {
    getStudentList();
  }, []);

  const getStudentList = () => {
    setLoading(true);
    LaddersDataService.getParentRoleStudentList()
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data && res?.data?.list && res?.data?.list.length > 0) {
            let studentArr = res?.data?.list || [];
            setStudentList(studentArr);
            setStudentId(studentArr[0]?.id);
            setLoading(false);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleChangeStudent = (e) => {
    setStudentId(e.target.value);
    setLoading(true); // Show loader immediately when student changes
  };

  useEffect(() => {
    if (studentList && studentList.length > 0 && studentId) {
      getParentInterest();
    }
  }, [studentList, studentId]);

  const getParentInterest = () => {
    let payload = {
      student_id: studentId || "",
    };
    setLoading(true);
    setLoading(true);
    PortFolioService.getParentRoleInterest(payload)
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data) {
            setChekcedInterest(res?.data?.interests);
            if (
              res?.data?.total_intrests &&
              res?.data?.total_intrests.length > 0
            ) {
              let orgInterestArr =
                res?.data?.total_intrests &&
                res?.data?.total_intrests.length > 0
                  ? res?.data?.total_intrests.map((item) => ({
                      ...item,
                      esName: item.name,
                    }))
                  : [];
              let interestArr =
                res?.data?.total_intrests &&
                res?.data?.total_intrests.length > 0
                  ? res?.data?.total_intrests.map((item) => ({
                      ...item,
                      esName: item.name,
                    }))
                  : [];

              if (langVal === "es") {
                getTranslatedVal(langVal, interestArr);
              } else {
                setAllInterest(orgInterestArr);
                setInterestList(interestArr);
              }
            }
            setLoading(false);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getTranslatedVal = (lang, intArr) => {
    let payload = {
      list_of_values: intArr.map((val) => val.name) || [],
      to: lang,
    };
    setLoading(true);
    MessageTemplateService.parentTranslateBragbook(payload)
      .then((res) => {
        if (res?.status === 200) {
          let esArr = res?.data?.list_of_results;
          let newArr = [...intArr];
          newArr.map((item, index) => (item.esName = esArr[index]));
          setInterestList(newArr);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner parentPassion">
            <div className="passion-ad-header">
              <div className="header-content">
                <div className="ad-section-centered">
                  <Advert />
                </div>
              </div>
            </div>

            <div className="interest-container">
              <Row>
                <Col lg="12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h1 className="title-main">My Brag Book</h1>
                    <Switch
                      onChange={handleChangeLanguage}
                      checked={language}
                      width={52}
                      height={24}
                      handleDiameter={18}
                      onColor={"#28131A"}
                      offColor={"#049804"}
                      uncheckedIcon={
                        <div className="switchIncon uncheckIcon">EN</div>
                      }
                      checkedIcon={
                        <div className="switchIncon checkIcon">ES</div>
                      }
                      className="langSwitch"
                    />
                  </div>
                </Col>
              </Row>
              {studentList && studentList.length > 0 && (
                <Row>
                  <Col lg="12">
                    <FormGroup className="text-left studentSelect">
                      <Input
                        className="form-control"
                        type="select"
                        name="studentId"
                        value={studentId || ""}
                        onChange={handleChangeStudent}
                      >
                        {studentList.map((item, index) => {
                          return (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg="12" className="mx-auto">
                  {loading ? (
                    <div className="loading-container">
                      <Loading />
                    </div>
                  ) : (
                    <div className="interest-items">
                      {interestList &&
                        interestList.map((item, index) => {
                          const isChecked =
                            chekcedInterest &&
                            chekcedInterest.length > 0 &&
                            chekcedInterest.find(
                              (elem) => elem.intrest_name === item.name
                            );
                          return (
                            <div key={index} className="interest-item">
                              <span className="item-text">{item.esName}</span>
                              <div className="check-icon-wrapper">
                                <img
                                  src={isChecked ? checkIcon : unCheckIcon}
                                  alt={isChecked ? "Checked" : "Unchecked"}
                                  className="check-icon"
                                />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentPassion;
